// User-supplied Takefold paper note. Never affects editing or project saves.
const SOUND_URL='/sounds/takefoldnote.mp3';
let context=null;
let bufferPromise=null;

function audio(){
  if(typeof window==='undefined')return null;
  const AudioContext=window.AudioContext || window.webkitAudioContext;
  if(!AudioContext)return null;
  try{context??=new AudioContext();return context;}catch{return null;}
}
function soundBuffer(ctx){
  if(!bufferPromise){
    bufferPromise=fetch(SOUND_URL)
      .then(response=>{if(!response.ok)throw Error('Takefold note could not load');return response.arrayBuffer();})
      .then(bytes=>ctx.decodeAudioData(bytes))
      .catch(()=>{bufferPromise=null;return null;});
  }
  return bufferPromise;
}

// Called in the E/key/click gesture, before any asynchronous passage processing.
export function primePaperPaste(){
  const ctx=audio();
  if(!ctx)return;
  if(ctx.state==='suspended')void ctx.resume().catch(()=>{});
  void soundBuffer(ctx);
}
// Called only after a passage has been successfully added.
export function playPaperPaste(){
  const ctx=audio();
  if(!ctx)return false;
  try{
    if(ctx.state==='suspended')void ctx.resume().catch(()=>{});
    void soundBuffer(ctx).then(buffer=>{
      if(!buffer || ctx.state==='closed')return;
      try{
        const source=ctx.createBufferSource();
        source.buffer=buffer;
        const volume=ctx.createGain();
        volume.gain.value=0.65;
        source.connect(volume);volume.connect(ctx.destination);
        source.start();
      }catch{/* Audio must never block adding a passage. */}
    });
    return true;
  }catch{return false;}
}
